import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import SocialLinks from "./SocialLinks";
import { navItems, site } from "../data/site";

const quickLinks = navItems.filter((item) => item.path !== "/");

const Footer = () => (
  <Box
    component="footer"
    sx={(theme) => ({
      mt: "auto",
      py: { xs: 4, md: 5 },
      borderTop: theme.tokens.hairline,
      // Keeps its own surface colour, which is darker than the page in dark
      // mode, and takes the grain on top so the paper runs to the bottom.
      backgroundColor: theme.palette.background.paper,
      ...theme.tokens.paper,
    })}
  >
    <Container maxWidth="lg">
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
          gap: { xs: 3, sm: 4 },
          alignItems: "start",
        }}
      >
        <Box>
          <Typography component="h2" variant="h6" sx={{ fontSize: "1.05rem", mb: 1 }}>
            {site.name}
          </Typography>
          {/* "Portfolio" said nothing a visitor on the portfolio needed. */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {site.headline}, based in {site.location}.
          </Typography>
          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} {site.name}
          </Typography>
        </Box>

        <Box>
          <Typography component="h2" variant="h6" sx={{ fontSize: "1.05rem", mb: 1 }}>
            Quick Links
          </Typography>
          <Box
            component="nav"
            aria-label="Footer"
            sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}
          >
            {quickLinks.map(({ label, path }) => (
              <Link
                key={path}
                component={RouterLink}
                to={path}
                variant="body2"
                color="text.secondary"
                sx={{
                  transition: "color 0.2s ease",
                  "&:hover": { color: "text.primary" },
                }}
              >
                {label}
              </Link>
            ))}
          </Box>
        </Box>

        <Box>
          <Typography component="h2" variant="h6" sx={{ fontSize: "1.05rem", mb: 1 }}>
            Connect
          </Typography>
          <SocialLinks size="medium" justify="flex-start" sx={{ ml: -1 }} />
        </Box>
      </Box>
    </Container>
  </Box>
);

export default Footer;
